import type { ComponentChildren } from 'preact';

export function CommunityHeader({ actions }: { actions?: ComponentChildren }) {
  return (
    <div class="mb-6">
      <div class="flex items-start gap-2 mb-1">
        <svg
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="text-indigo-500 mt-1"
          style="width: 24px; height: 24px; flex-shrink: 0"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
          />
        </svg>
        <h1 class="flex-1 text-2xl font-bold text-gray-900 dark:text-white">AI Playground</h1>
        {actions && <nav class="hidden lg:inline-flex items-center gap-6">{actions}</nav>}
      </div>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        AI-powered momentum for coaches and consultants
      </p>
    </div>
  );
}
